module.exports = __webpack_public_path__ + "static/img/v6.4dcf051.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v6.jpg
// module id = B90M
// module chunks = 1